import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ClientService } from "../../services/client.service";
import { RegionResolve } from "../../services/region.resolve";
import { LocalizationService } from "../../services/localization";
import { ClientResolve } from "../../services/client.resolve";

@NgModule({
    imports: [CommonModule],
    declarations: [],
    providers: [
        { provide: "localeCode", useValue: navigator.language || (navigator as any).browserLanguage || "en" },
        ClientService,
        RegionResolve,
        ClientResolve,
        LocalizationService,
    ],
})
export class HomePageProviderModule {}
